<div class="page">



  <div class="overlay">

  </div>

  <div class="pricingTitles container">

    <div class="innerPricingTitles">
      <p class="pageTitle">Pricing and Bundles</p>
      <p class="paidAnually">Paid Anually</p>

    </div>
    <p class="subpageTitle">
      Our bundles are carefully designed to accommodate all your business needs.
    </p>
    <mat-select [(ngModel)]="location" class="dropdown">
      <mat-select-trigger>
        <span class="dropdownMenu">
          <img [src]=location.flag />
          <p class="dropdownMenu1">{{location.label}}</p>
          <p class="dropdownMenu2">{{location.currency}}</p>
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let item of locations" [value]="item" class="">

        <div class="d-flex dropdownMenu">
          <img [src]=item.flag />
          <p class="dropdownMenu1">{{item.label}}</p>
          <p class="dropdownMenu3">{{item.currency}}</p>
        </div>

      </mat-option>
    </mat-select>

  </div>



  <div class="pricingCardSelection container">
    <p *ngFor="let item of pricingPackages" (click)="selectedPlan=item"
      [ngClass]="selectedPlan==item? 'selected' : '' ">{{item.name}}</p>
  </div>


  <div class="pricingCards container">

    <div [ngClass]="selectedPlan!=pricingPackages[0] ? 'hide' : '' " class="pricingCard">
      <div class="pricingCardHeader">
        <p class="pricingCardHeaderTitle">{{pricingPackages[0].name}}</p>
        <div class="pricingCardsubeader">
          <p class="egp">EGP</p>
          <p class="pricingCardsubeader1">{{pricingPackages[0].price}}</p>
          <p class="student">/Student</p>
        </div>
      </div>

      <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      <div class="features">

        <div *ngFor="let item of pricingPackages[0].features" class="feature"><img
            src="../../../assets/images/blueCheck.svg" />
          <p>{{item}}</p>
        </div>


      </div>
    </div>


    <div [ngClass]="selectedPlan!=pricingPackages[1] ? 'hide' : '' " class="pricingCard">
      <div class="pricingCardHeader">
        <p class="pricingCardHeaderTitle">{{pricingPackages[1].name}}</p>
        <div class="pricingCardsubeader">
          <p class="egp">EGP</p>

          <p class="pricingCardsubeader1">{{pricingPackages[1].price}}</p>
          <p class="student">/Student</p>
        </div>
      </div>

      <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      <div class="features">

        <div *ngFor="let item of pricingPackages[1].features" class="feature"><img
            src="../../../assets/images/blueCheck.svg" />
          <p>{{item}}</p>
        </div>


      </div>

      <!-- <div (click)="showAdditionalFeatures=!showAdditionalFeatures" class="cardAdditionalFeatures">
        <p>Additional Features</p>
        <img [ngClass]="showAdditionalFeatures ? '' : 'addFRotate' " src="../../../assets/images/chevron.purple.svg" />
      </div>

      <div *ngIf="showAdditionalFeatures" class="features">

        <div *ngFor="let item of pricingPackages[1].additionalFeatures" class="feature"><img
            src="../../../assets/images/blueCheck.svg" />
          <p>{{item}}</p>
        </div>


      </div> -->
    </div>


    <div [ngClass]="selectedPlan!=pricingPackages[2] ? 'hide' : '' " class="pricingCard bestPricingCard">

      <div class="cardBestValue">
        <p>Best Value</p>
      </div>

      <div class="pricingCardHeader">
        <p class="pricingCardHeaderTitle">{{pricingPackages[2].name}}</p>
        <div class="pricingCardsubeader">
          <p class="egp">EGP</p>

          <p class="pricingCardsubeader1">{{pricingPackages[2].price}}</p>
          <p class="student">/Student</p>
        </div>
      </div>

      <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      <div class="features">

        <div *ngFor="let item of pricingPackages[2].features" class="feature"><img
            src="../../../assets/images/checkPriceWhite.svg" />
          <p>{{item}}</p>
        </div>


      </div>
    </div>


    <div [ngClass]="selectedPlan!=pricingPackages[3] ? 'hide' : '' " class="pricingCard">
      <div class="pricingCardHeader">
        <p class="pricingCardHeaderTitle">{{pricingPackages[3].name}}</p>
        <div class="pricingCardsubeader">
          <p style="font-size: 22px;" class="pricingCardsubeader1">Request Quotation</p>


        </div>
      </div>

      <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      <div class="features">


        <div class="feature"><img src="../../../assets/images/blueCheck.svg" />
          <p style="font-weight: 700;">{{pricingPackages[3].features[0]}}</p>
        </div>

        <div *ngFor="let item of pricingPackages[3].features | slice : 1:pricingPackages[3].features.length"
          class="feature"><img src="../../../assets/images/blueCheck.svg" />
          <p>{{item}}</p>
        </div>


      </div>
    </div>

  </div>



  <a href="/pricing123#additionalFeatures" class="readyForMore">

    <img class="triangles" src="../../../assets/images/2PurpleTriangles.svg" />
    <div class="readyForMoreText">
      <p class="readyForMoreText1">Ready for more?</p>
      <p class="readyForMoreText2">Explore Additional features <img src="../../../assets/images/down.svg" /></p>
    </div>

  </a>


  <!-- <table class="valueTable">
    <tr>
      <th></th>
      <th [ngClass]="element.bestValue ? 'bestValue' : '' " *ngFor="let element of pricingPackages"><span
          *ngIf="element.bestValue">Best Value</span></th>
    </tr>
  </table> -->


  <p class="pageTitle container">Compare Plans</p>

  <div class="pricingCardSelection pricingCardSelection2 container">
    <p *ngFor="let item of pricingPackages" (click)="selectedPlan=item"
      [ngClass]="selectedPlan==item? 'selected' : '' ">{{item.name}}</p>
  </div>


  <table class="pricingTable container">






    <tr class="outerTr hide">
      <th></th>
      <th *ngFor="let element of pricingPackages" [style.backgroundColor]="element.bestValue ? '#F5F5F5' : '' ">
        {{element.name}}</th>
    </tr>

    <!-- <tr class="priceTr">
      <th></th>
      <th [style.backgroundColor]="element.bestValue ? '#F8F2FF' : '' " *ngFor="let element of pricingPackages"><span
          class="price1">{{element.price}}</span>&nbsp;<span class="price2"> /student/year</span></th>
    </tr> -->

    <tr class="innerTr" *ngFor="let feature of dataSource">
      <th style="border-right: 2px solid  #F2F2F2;" class="firstInnerTr">
        <p>{{feature.name}}</p>
      </th>
      <th class="restInnerTr hide" [style.backgroundColor]="element.bestValue ? '#F5F5F5' : '' "
        *ngFor="let element of pricingPackages">

        <p *ngIf="element[feature.id] && element[feature.id] != true && element[feature.id] !=false"
          class="featureInTable">{{element[feature.id]}}</p>
        <img *ngIf="element[feature.id] == true" src="../../../assets/images/checkPrice.svg" />
        <img *ngIf="!element[feature.id]" src="../../../assets/images/x.svg" />

      </th>


      <th class="restInnerTr hideWeb" [style.backgroundColor]="selectedPlan.bestValue ? '#F5F5F5' : '#F5F5F5' ">


        <p *ngIf="selectedPlan[feature.id] && selectedPlan[feature.id] != true && selectedPlan[feature.id] !=false"
          class="featureInTable">{{selectedPlan[feature.id]}}</p>

        <img *ngIf="selectedPlan[feature.id]==true" src="../../../assets/images/checkPrice.svg" />
        <img *ngIf="!selectedPlan[feature.id]" src="../../../assets/images/x.svg" />

      </th>


    </tr>




  </table>
    <div class="pricingTitles container" id="additionalFeatures">

      <div class="innerPricingTitles ">
        <p class="pageTitle">Enhance Your Plan with Additional Features</p>

      </div>
      <p class="subpageTitle">
        Find out more about our paid features
      </p>


    </div>

    <div class="additionalFeatures container">
      <div class="additionalFeaturesCard">
        <div class="additionalFeaturesCardrow additionalFeaturesCardrow1">
          <img src="../../../assets/images/ad1.svg" />
          <p class="additionalFeaturesCardBody">Across all packages</p>

        </div>
        <p class="additionalFeaturesCardTitle">Increase Permission Levels</p>

        <p class="additionalFeaturesCardSubTitle">Integration system (with Landing Managment System or School Management
          System)</p>
        <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      </div>



      <div class="additionalFeaturesCard">
        <div class="additionalFeaturesCardrow additionalFeaturesCardrow1">
          <img src="../../../assets/images/ad2.svg" />
          <p class="additionalFeaturesCardBody">Across all packages</p>

        </div>
        <p class="additionalFeaturesCardTitle">Consumer Financing</p>

        <p class="additionalFeaturesCardSubTitle">Integration system (with Landing Managment System or School Management
          System)</p>
        <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      </div>



      <div class="additionalFeaturesCard">
        <div class="additionalFeaturesCardrow additionalFeaturesCardrow1">
          <img src="../../../assets/images/ad3.svg" />
          <p class="additionalFeaturesCardBody">Across all packages</p>

        </div>
        <p class="additionalFeaturesCardTitle">Removing ADs</p>

        <p class="additionalFeaturesCardSubTitle">Integration system (with Landing Managment System or School Management
          System)</p>
        <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      </div>


      <div class="additionalFeaturesCard">
        <div class="additionalFeaturesCardrow additionalFeaturesCardrow1">
          <img src="../../../assets/images/ad4.svg" />
          <p class="additionalFeaturesCardBody">For advanced package</p>

        </div>
        <p class="additionalFeaturesCardTitle">Automating Reminders</p>

        <p class="additionalFeaturesCardSubTitle">Integration system (with Landing Managment System or School Management
          System)</p>
        <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      </div>



      <div class="additionalFeaturesCard">
        <div class="additionalFeaturesCardrow additionalFeaturesCardrow1">
          <img src="../../../assets/images/ad5.svg" />
          <p class="additionalFeaturesCardBody">For advanced package</p>

        </div>
        <p class="additionalFeaturesCardTitle">Consolidated Dashboard for All Branches</p>

        <p class="additionalFeaturesCardSubTitle">System or School Management System)</p>
        <p (click)="goToSales()" class="ctaButton">Contact Sales</p>

      </div>



    </div>


  <!-- <a class="ctaButton3" href="/sales" target="_blank" style="margin: auto;">
    Contact Sales
    <span style="margin-bottom: 3px;"><img src="../../../assets/images/chevron.right.white.svg" /></span>
  </a> -->

</div>